import { Box, styled } from '@mui/material';

export const Page = styled(Box)({
  color: 'black',
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
});

export const PageTitle = styled(Box)({
  display: 'flex',
  color: 'black',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '28px',
  letterSpacing: '0px',
  margin: '0 15px 0 15px',
  paddingBottom: '15px',
  borderBottom: 'solid 1px #E9EAEE',
  paddingLeft: '5px',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const PageContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  margin: '20px 20px 20px',
  height: '100%'
});

export const HSeparator = styled(Box)({
  display: 'flex',
  height: '1px',
  margin: '0 20px',
  backgroundColor: ' #E9EAEE'
});

export const Toolbar = styled(Box)({
  padding: '15px 19px 19px 19px',
  borderTop: 'solid 1px #E1E4E7',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 'auto'
});
